import { graphql } from 'react-relay';

export const markdownBlockFragment = graphql`
    fragment MarkdownBlock_contentBlock on MarkdownBlock {
        markdown
    }
`;
